/**
 * A link the assistant puts in a message points either at a PMP page or somewhere
 * else entirely. The panel opens a link in a new tab unless the app claims it, so
 * this decides which hrefs the router should take over.
 */

/**
 * The href as a path this app's router can navigate to, or null when it points
 * outside the app. `origin` is the app's own origin (`window.location.origin`),
 * passed in so this stays testable without a DOM.
 */
export const toInAppPath = (href: string, origin: string): string | null => {
  const trimmed = href.trim();
  if (!trimmed) return null;

  let url: URL;
  try {
    url = new URL(trimmed, origin);
  } catch {
    return null;
  }

  // A `javascript:` or `mailto:` href parses with no origin, and `//host/path`
  // parses with the other host's, so both fail this and open in a tab instead.
  if (url.origin !== origin) return null;

  return `${url.pathname}${url.search}${url.hash}`;
};
